<router-outlet></router-outlet>
<!-- TODO Add global footer? -->

<app-toast></app-toast>
